<template>
  <v-form>
    <gg-text-field
      label="Name"
      name="Name"
      placeholder="Valid zone name"
      v-model="model.name"
      v-validate="rules.name"
      :error-messages="errors.collect('Name')"
      @input="sendData"></gg-text-field>
    <gg-text-field
      label="TTL"
      name="TTL"
      placeholder="14400"
      v-model="model.ttl"
      v-validate="rules.ttl"
      :error-messages="errors.collect('TTL')"
      @input="sendData"></gg-text-field>
    <gg-text-field
      label="Canonical name"
      name="Canonical name"
      placeholder="example.com"
      v-model="model.cname"
      v-validate="rules.cname"
      :error-messages="errors.collect('Canonical name')"
      @input="sendData"></gg-text-field>
  </v-form>
</template>

<script>
import { ZoneRecord } from '@/mixins/ZoneRecord'

export default {
  name: 'CNameRecordForm',
  mixins: [ZoneRecord],
  inject: ['parentValidator'],
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      model: {
        name: '',
        ttl: '14400',
        cname: ''
      },
      rules: {
        name: { required: true },
        ttl: { required: true, numeric: true },
        cname: { required: true, url: true }
      }
    }
  },
  methods: {
    fillEditData () {
      for (let key in this.item) {
        if (this.item.hasOwnProperty(key)) {
          this.model[key] = this.item[key]
        }
      }
    }
  },
  created () {
    this.$validator = this.parentValidator
    // If props "edit" is true, it`s mean that we use current component for edit a record, then execute next function
    if (this.edit) {
      this.fillEditData()
    }
    this.sendData()
  }
}
</script>
